/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import Localized from '../../../shared/components/Localized';
import { UtilityIcon } from '../SVGIcon';
import styles from '../../styles';

const Wrapper = styled.div`
  position: fixed;
  top: ${(p) => {
    return (p.top ? p.top + 'px' : '3rem');
  }};
  left: 0;
  right: 0;
  height: ${(p) => {
    return (p.top ? p.height + 'px' : '2.5rem');
  }};
  line-height: 2.5rem;
  z-index: 60;
  font-size: 14px;
  background-color: ${styles.colors.navy200};
`;

const Icon = styled.span`
  padding-left: 20px;
  padding-right: 0.75rem;
`;

const StyledUtilityIcon = styled(UtilityIcon)`
  line-height: 2.5rem;
`;

const Text = styled.span`
  line-height: 2.5rem;
  color: white;
`;

const StyledLink = styled(Link)`
  :hover {
    text-decoration: none;
  }
`;

const BackBar = (props) => {
  return (
    <Wrapper
      top={props.marginTop}
      height={props.height}
    >
      <StyledLink
        onClick={() => {
          if (props.onClick) {
            props.onClick();
          }
        }}
        to={'/'}
      >
        <Icon>
          <UtilityIcon icon="back" fill="#FFFFFF" size="1rem" round />
        </Icon>
        <Text>
          <Localized modelKey="status" modelAttribute="header" modelName="bucketedList" />
        </Text>
      </StyledLink>
    </Wrapper>
  );
};

export default BackBar;
